
export default function LocationSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary mb-4">
            Serving Columbia, Maryland
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            U.B.K Window Tint provides professional window tinting services to
            Columbia and the surrounding Howard County area. Our mobile service
            brings premium ceramic tint installation directly to your location.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h3 className="text-2xl font-bold text-secondary mb-4">
              Why Choose Us in Columbia?
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-accent text-xl mr-3 mt-1 w-6 h-6 flex items-center justify-center"></i>
                <span className="text-gray-700">
                  <strong>Local Expertise:</strong> Serving Columbia and Howard
                  County with specialized tinting solutions
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-car-line text-accent text-xl mr-3 mt-1 w-6 h-6 flex items-center justify-center"></i>
                <span className="text-gray-700">
                  <strong>Mobile Service:</strong> We come to your home, office,
                  or anywhere in Columbia
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-shield-check-line text-accent text-xl mr-3 mt-1 w-6 h-6 flex items-center justify-center"></i>
                <span className="text-gray-700">
                  <strong>Lifetime Warranty:</strong> All window tinting services
                  come with a lifetime warranty
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-time-line text-accent text-xl mr-3 mt-1 w-6 h-6 flex items-center justify-center"></i>
                <span className="text-gray-700">
                  <strong>Same Day Service:</strong> Fast, professional
                  installation available in Columbia
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-lg">
            <h3 className="text-2xl font-bold text-secondary mb-4">
              Columbia Service Areas
            </h3>
            <p className="text-gray-700 mb-4">
              We provide professional window tinting services throughout Columbia
              and nearby communities including:
            </p>
            <div className="grid grid-cols-2 gap-3 text-sm text-gray-600">
              <div>• Columbia</div>
              <div>• Ellicott City</div>
              <div>• Laurel</div>
              <div>• Clarksville</div>
              <div>• Savage</div>
              <div>• Jessup</div>
              <div>• Fulton</div>
              <div>• Highland</div>
              <div>• Scaggsville</div>
              <div>• Elkridge</div>
            </div>
            <div className="mt-6 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-600 mb-2">
                <strong>Contact Us:</strong>
              </p>
              <p className="text-lg font-bold text-accent">(443) 800-0348</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
